var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { ActivatedRoute, Router } from '@angular/router';
var ForgotPasswordComponent = /** @class */ (function () {
    function ForgotPasswordComponent(util, apiService, activatedRoute, router) {
        this.util = util;
        this.apiService = apiService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.submitted = false;
        this.foundEmail = null;
        this.emailField = "";
        this.isValidMail = false;
        this.resetType = "";
        this.isCrisis = false;
        this.showOkBtn = true;
        this.menuEnabled = false;
    }
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var config, crisisConfig, menuList, thisMenu;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetType = this.activatedRoute.snapshot.queryParams['type'];
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        config = _a.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            this.isCrisis = true;
                        }
                        else {
                            this.isCrisis = false;
                        }
                        return [4 /*yield*/, this.apiService.get("master", "customerPortalMenuSetting")];
                    case 2:
                        menuList = _a.sent();
                        thisMenu = this.util.getMenuObj(menuList, "11", this.isCrisis);
                        if (!thisMenu.show) {
                            this.util.ShowWaiting(false);
                            setTimeout(function () {
                                _this.router.navigate(["mainmenu/index"]);
                            }, 500);
                            return [2 /*return*/];
                        }
                        else {
                            this.menuEnabled = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ForgotPasswordComponent.prototype.checkEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res, thisTs_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        this.isValidMail = this.validateEmail();
                        if (!this.isValidMail) return [3 /*break*/, 2];
                        this.foundEmail = null;
                        this.util.ShowWaiting(true);
                        req = {
                            username: this.emailField.trim(),
                            resetType: this.resetType,
                            url: this.util.baseUrl()
                        };
                        return [4 /*yield*/, this.apiService.postCustomApi("User", "Forgot", req)];
                    case 1:
                        res = _a.sent();
                        if (res.code == "200") {
                            this.foundEmail = true;
                        }
                        else if (res.code == "99") {
                            this.foundEmail = false;
                        }
                        else if (res.code == "400") {
                            this.util.ErrorDialog(res.msg);
                        }
                        else if (res.code == "208") {
                            thisTs_1 = this;
                            this.util.ErrorDialog("กรุณารอสักครู่ ท่านได้ทำรายการเกินจำนวนครั้งที่กำหนด");
                            $("#btnMainError").off("click");
                            $("#btnMainError").click(function () {
                                thisTs_1.router.navigate(["/mainmenu/index"]);
                            });
                        }
                        else {
                            this.util.ErrorDialog("เกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่");
                        }
                        this.util.ShowWaiting(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ForgotPasswordComponent.prototype.validateEmail = function () {
        if (this.emailField.trim().length > 0) {
            var matches = this.emailField.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? true : false;
        }
        else {
            return false;
        }
    };
    //วิกฤติ ส่ง useridno ปกติ ส่ง mail
    ForgotPasswordComponent.prototype.SendEmail = function (TokenID, logsendmailid, emailAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var MailObj, MailContent, url, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        MailObj = {
                            //contactid: this.PortalLogin.customerid,
                            dpa_name: this.PortalLogin.firstname + " " + this.PortalLogin.lastname
                        };
                        MailContent = "";
                        url = this.util.baseUrl() + "/resetPassword?id=" + TokenID;
                        if (this.resetType == "username") {
                            MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
                                "   ระบบได้รับคำขอรหัสผู้ใช้งาน(" + (this.isCrisis ? this.PortalLogin.usernameidno : this.PortalLogin.username) + " )ของบัญชีผู้ใช้งาน Customer Web Portal ของคุณ <br /><br />" +
                                "รหัสผู้ใช้งานของคุณ : " + (this.isCrisis ? this.PortalLogin.usernameidno : this.PortalLogin.username) + " โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
                                '<a target="_blank" href="' + url + '">' + url + "</a><br /><br />" +
                                "ขอแสดงความนับถือ <br />" +
                                "สถาบันคุ้มครองเงินฝาก <br />" +
                                "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
                                "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
                                "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
                                "โทร : 02-272-0300";
                        }
                        else {
                            MailContent = "เรียน คุณ" + this.PortalLogin.firstname + " " + this.PortalLogin.lastname + "<br /><br />" +
                                "   ระบบได้รับคำขอให้ตั้งรหัสผ่านใหม่ของบัญชีผู้ใช้งาน Customer Web Portal ของคุณ <br />" +
                                "รหัสผู้ใช้งานของคุณ : " + (this.isCrisis ? this.PortalLogin.usernameidno : this.PortalLogin.username) + " โปรดคลิกลิงค์ด้านล่างเพื่อตั้งรหัสผ่าน <br /><br />" +
                                '<a target="_blank" href="' + url + '">' + url + "</a><br /><br />" +
                                "ขอแสดงความนับถือ <br />" +
                                "สถาบันคุ้มครองเงินฝาก <br />" +
                                "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
                                "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
                                "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
                                "โทร : 02-272-0300";
                        }
                        MailObj.dpa_emailaddress = emailAddress;
                        MailObj.logsendmailid = logsendmailid;
                        MailObj.dpa_description = MailContent;
                        MailObj.dpa_callby = 2;
                        return [4 /*yield*/, this.apiService.post("crmservice", "sendEmail", MailObj)];
                    case 1:
                        Res = _a.sent();
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    return ForgotPasswordComponent;
}());
export { ForgotPasswordComponent };



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts.pre-build-optimizer.js